import { Component, OnInit, ViewChild  } from '@angular/core';
import { environment } from 'environments/environment';
import { Logger } from 'app/core/logger.service';
import * as Models from 'app/core/models';

const log = new Logger('App');
@Component({
    selector: 'app-login-modal',
    templateUrl: './loginModal.component.html',
    styleUrls: ['./loginModal.component.scss']
})

export class LoginModalComponent implements OnInit, Models.ModalComponent {

    version: string = environment.version;

    @ViewChild('modalLogin') public contentModal: any;

    constructor() {
    }

    ngOnInit() {

    }

    openModal() {
        this.contentModal.show();
    }

    closeModal() {
        this.contentModal.hide();
    }

}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/login/loginModal.component.ts